<template>
    <div class="container">
        <div class="row" v-if="isLoading">
            <spinner :msg="'loading, please wait...'"></spinner>
        </div>

        <div class="page-header" role="heading" v-if="!isLoading">
            <div class="row">
                <div class="col-xs-12">
                    <h2 class="narrow">Bail Agent Search</h2>
                </div>
            </div>
            <div class="row" v-show="showSearch">
                <div class="col-xs-12 helptext">
                    Search for publicly accessible information about bonds posted by licensed bail agents. Bonds posted beginning July 1, 2022.<br />
                    For more information about specific cases, please visit <a href="https://mycase.IN.gov" target="_blank">mycase.IN.gov</a> or <a href="https://m.in.gov/CourtContacts" target="_blank">contact the county Clerk’s Office.</a>
                </div>
            </div>
        </div>

        <!--Search Section-->
        <div v-show="showSearch">

            <div class="row">

                <div class="col-sm-8">
                    <h3 class="nopadmargin">Search By:</h3>

                    <!-- Posted Date Range -->
                    <div class="row moderatetop">
                        <div class="col-sm-3">
                            <div class="radio margin-top-0">
                                <label class="active control-label">
                                    <input checked type="radio" :value="searchType.DateRange" v-model="searchCriteria.SearchType" @change="searchTypeChange(searchType.DateRange)" />Posted Date
                                </label>
                            </div>
                        </div>

                        <div class="col-sm-5 col-md-4 col-lg-3">
                            <div class="form-group pad-bottom-0" :class="{'has-error':v$.searchCriteria.BeginDate.$error && isDateRangeSearch}">
                                <input type="text" ref="BeginDate" placeholder="MM/DD/YYYY (Begin)" class="form-control" v-mask="dateMask" v-model='searchCriteria.BeginDate' autofocus
                                       @keydown.enter.stop.prevent="runSearch()"
                                       :class="{'disabled':!isDateRangeSearch}" :disabled="!isDateRangeSearch" />
                                <div v-if="v$.searchCriteria.BeginDate.$error && isDateRangeSearch">
                                    <div v-if="v$.searchCriteria.BeginDate.required.$invalid">
                                        <p><small class="text-danger">Begin Date is Required</small></p>
                                    </div>
                                    <div v-if="v$.searchCriteria.BeginDate.valid.$invalid">
                                        <p><small class="text-danger">Begin Date is not valid</small></p>
                                    </div>
                                    <div v-if="v$.searchCriteria.BeginDate.minValue.$invalid">
                                        <p><small class="text-danger">Begin Date must be on or after 7/1/2022</small></p>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group pad-bottom-0" :class="{'has-error':v$.searchCriteria.EndDate.$error && isDateRangeSearch}">
                                <input type="text" name="EndDate" placeholder="MM/DD/YYYY (End)" class="form-control" v-mask="dateMask" v-model='searchCriteria.EndDate'
                                       @keydown.enter.stop.prevent="runSearch()"
                                       :class="{'disabled':!isDateRangeSearch}" :disabled="!isDateRangeSearch" />
                                <div v-if="v$.searchCriteria.EndDate.valid.$invalid && isDateRangeSearch">
                                    <small class="text-danger">End Date is not valid</small><br />
                                </div>
                                <div v-if="v$.searchCriteria.EndDate.minValue.$invalid && isDateRangeSearch">
                                    <small class="text-danger">End Date must be after Begin Date</small><br />
                                </div>
                                <div v-if="v$.searchCriteria.EndDate.isDateRangeValid.$invalid && isDateRangeSearch">
                                    <small class="text-danger">Posted Date Range must be 1 year or less</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr />

                    <!-- Bail Agent -->
                    <div class="row moderatetop">
                        <div class="col-sm-3">
                            <div class="radio margin-top-0">
                                <label class="control-label">
                                    <input type="radio" :value="searchType.BailAgent" v-model="searchCriteria.SearchType" @change="searchTypeChange(searchType.BailAgent)" />Bail Agent
                                </label>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="row">
                                <div class="col-sm-5">
                                    <div class="form-group" :class="{'has-error':v$.searchCriteria.LastName.$error && isBailAgentSearch}">
                                        <input class="form-control" ref="LastName" type="text" v-model="searchCriteria.LastName" autofocus
                                               @input="v$.searchCriteria.LastName.$touch()" placeholder="Business or Last Name"
                                               @keydown.enter.stop.prevent="runSearch()"
                                               :class="{'disabled':!isBailAgentSearch}" :disabled="!isBailAgentSearch" />
                                    </div>
                                    <div v-if="v$.searchCriteria.LastName.$error && isBailAgentSearch">
                                        <small class="text-danger" v-if="v$.searchCriteria.LastName.required.$invalid">Last Name is Required</small>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <!-- :class="{'has-error':v$.searchCriteria.FirstName.$error && isBailAgentSearch}">-->
                                        <input class="form-control" type="text" v-model="searchCriteria.FirstName"
                                               @keydown.enter.stop.prevent="runSearch()"
                                               @input="v$.searchCriteria.FirstName.$touch()" placeholder="First Name"
                                               :class="{'disabled':!isBailAgentSearch}" :disabled="!isBailAgentSearch" />
                                    </div>
                                    <!--<div v-if="v$.searchCriteria.FirstName.$error && isBailAgentSearch">
                            <small class="text-danger" v-if="v$.searchCriteria.FirstName.required.$invalid">First Name is Required</small>
                        </div>-->
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <input class="form-control" type="text" v-model="searchCriteria.MiddleName" placeholder="Middle Name"
                                               @keydown.enter.stop.prevent="runSearch()"
                                               :class="{'disabled':!isBailAgentSearch}" :disabled="!isBailAgentSearch" />
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-sm-5">
                                    <div class="form-group">
                                        <!--:class="{'has-error':this.isBailAgentSearch && this.v$.searchCriteria.LicenseNumber.$error}">-->
                                        <input class="form-control" type="text" v-model="searchCriteria.LicenseNumber" @input="v$.searchCriteria.LicenseNumber.$touch()"
                                               @keydown.enter.stop.prevent="runSearch()" placeholder="License Number"
                                               :class="{'disabled':!isBailAgentSearch}" :disabled="!isBailAgentSearch" />
                                    </div>
                                    <!--<div v-if="this.isBailAgentSearch && this.v$.searchCriteria.LicenseNumber.$error">
                            <small class="text-danger" v-if="v$.searchCriteria.LicenseNumber.required.$invalid">Bail Agent License Number is Required</small>
                        </div>-->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-7">
                            <div class="btn-toolbar btn-group-horizontal text-center">
                                <button type="button" class="btn btn-success" @click="runSearch()" :class="{'disabled':hasError}" :disabled="hasError" aria-label="search">
                                    <span class="fa fa-search"> Search</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <p class=”clearfix-xs”></p>

                <div class="col-sm-4 tips">
                    <div class="panel">
                        <div class="panel-body">
                            <div class="row">
                                <div class="col-xs-12">
                                    <h3 class="margin-top-0">Search Tips</h3>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-xs-12">
                                    <h4 class="margin-bottom-0">Posted Date Range</h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <p class="helptext">
                                        A Date Range is required for this search. At most a full year of bail data may be returned for a single search.<br />NOTE: Bail data is available only back to July 1st, 2022.
                                    </p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-xs-12">
                                    <h4 class="margin-bottom-0">Bail Agent Name &amp; License Number</h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <p class="helptext">
                                        Only the Business Name or Last Name is required for this search type.
                                        Partial name searches are supported but must match on the first characters for each respective name field.
                                        While optional, the License Number must be an exact match.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!--Results Section-------------------------------------------------------->
        <div v-show="showResults">

            <div class="row nopadmargin">
                <div class="col-sm-12 nopadmargin">
                    <h4>Search Results</h4>
                </div>
            </div>
            <hr />
            <div class="row">
                <div v-if="searchCriteria.SearchType == searchType.DateRange" class="col-sm-2 text-nowrap text-muted search-criteria">
                    <div>Date Range Search:</div>
                    <div v-show="searchCriteria.BeginDate" class="grid-container">
                        <p>Begin Date:</p>
                        <p>{{searchCriteria.BeginDate}}</p>
                    </div>
                    <div v-show="searchCriteria.EndDate" class="grid-container">
                        <p>End Date:</p>
                        <p>{{searchCriteria.EndDate}}</p>
                    </div>
                </div>
                <div v-if="searchCriteria.SearchType == searchType.BailAgent" class="col-sm-2 text-nowrap text-muted search-criteria">
                    <div>Bail Agent Search:</div>
                    <div v-show="searchCriteria.FirstName" class="grid-container">
                        <p>First Name:</p>
                        <p>{{searchCriteria.FirstName}}</p>
                    </div>
                    <div v-show="searchCriteria.MiddleName" class="grid-container">
                        <p>Middle Name:</p>
                        <p>{{searchCriteria.MiddleName}}</p>
                    </div>
                    <div v-show="searchCriteria.LastName" class="grid-container">
                        <p>Last Name:</p>
                        <p>{{searchCriteria.LastName}}</p>
                    </div>
                    <div v-show="searchCriteria.LicenseNumber" class="grid-container">
                        <p>License Number:</p>
                        <p>{{searchCriteria.LicenseNumber}}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-7 col-sm-7 btn-toolbar btn-group-horizontal text-center">
                    <button class="btn btn-default" @click="setSearchView()">
                        <i class="fa fa-arrow-left"></i> Refine Search
                    </button>
                    <button class="btn btn-default" @click="clear()">
                        <i class="fa fa-search"></i> New Search
                    </button>
                    <button class="btn btn-default" @click="download(bailData)">
                        <i class="fa fa-file"></i> Download CSV
                    </button>
                </div>
                <div class="col-xs-5 col-sm-5 text-right">
                    <span v-html="searchResultDescription"></span>
                </div>
            </div>
            <hr />

            <div v-for="(b, index) in bailData" :key="index">
                <search-result :bailRecord="b"></search-result>
            </div>
        </div>

        <!--No Results Section--------------------------------------------------------------------->
        <div v-show="showNoResults">
            <div class="row">
                <div class="col-sm-12">
                    <h2>Search Results</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="btn-toolbar btn-group-horizontal text-center">
                        <button class="btn btn-default" @click="setSearchView()">
                            <i class="fa fa-arrow-left"></i> Refine Search
                        </button>
                        <button class="btn btn-default" @click="clear()">
                            <i class="fa fa-search"></i> New Search
                        </button>

                    </div>
                </div>
            </div>
            <hr />
            <div class="col-sm-12">
                <h3 style="margin-top:10px;">Your search did not return any results.</h3>
            </div>
        </div>
    </div>
</template>

<script>
    //-------------------------------------------------------------
    import api from "@/utils/api"
    import SearchCriteria from "@/models/SearchCriteria"
    import SearchType from "@/models/SearchType"
    import SearchResult from "@/components/SearchResult"
    import spinner from "@/components/Spinner"
    import { useVuelidate } from '@vuelidate/core'
    import { requiredIf } from '@vuelidate/validators'
    import moment from 'moment';
    import swal from "sweetalert"
    //-------------------------------------------------------------
    export default {
        name: "Search",
        components: { spinner, SearchResult },
        setup() {
            return { v$: useVuelidate() }
        },
        data() {
            return {

                isLoading: true,

                view: 'search',

                bailData: [],

                searchCriteria: new SearchCriteria(),

                searchType: new SearchType(),

                dateMask: {
                    mask: '1#/3#/20##',
                    tokens: {
                        '#': { pattern: /\d/ },
                        '0': { pattern: /[0-9]/ },
                        '1': { pattern: /[0-1]/ },
                        '2': { pattern: /[12]/ },
                        '3': { pattern: /[0-3]/ }
                    }
                }
            }
        },

        async created() {
            ct.pa.notify.clear();
            this.searchCriteria.SearchType = this.searchType.DateRange;
        },

        mounted() {
            this.isLoading = false;
            this.$refs.BeginDate.focus();
        },

        computed: {

            isDevelopment: function () { return (process.env.NODE_ENV == "development"); },

            hasBailData: function () { return (this.bailData && this.bailData.rows.length > 0) ? true : false; },

            isDateRangeSearch: function () { return (this.showSearch && this.searchCriteria.SearchType == this.searchType.DateRange) ? true : false; },
            isBailAgentSearch: function () { return (this.showSearch && this.searchCriteria.SearchType == this.searchType.BailAgent) ? true : false; },

            hasDateRangeError: function () {
                return (this.isDateRangeSearch && (this.v$.searchCriteria.BeginDate.$error || this.v$.searchCriteria.EndDate.$error));
            },

            hasBailAgentError: function () {
                return (this.isBailAgentSearch && this.v$.searchCriteria.LastName.$error);
                //(this.v$.searchCriteria.LicenseNumber.$error || this.v$.searchCriteria.FirstName.$error || this.v$.searchCriteria.LastName.$error));
            },

            hasError: function () { return (this.hasBailAgentError || this.hasDateRangeError); },

            searchResultDescription: function () {
                return String(this.bailData.length) + ((this.bailData.length == 1) ? " result" : " results");
            },

            showSearch: function () { return (!this.isLoading && this.view == "search"); },

            showResults: function () { return (!this.isLoading && this.view == "results"); },

            showNoResults: function () { return (!this.isLoading && this.view == "noresults"); },

        },

        methods: {

            clear() {
                this.v$.$reset();
                this.searchCriteria = new SearchCriteria();
                this.bailData = [];
                this.searchCriteria.SearchType = this.searchType.DateRange;
                this.setSearchView();
            },

            handleResponse(res) {

                if (res.data.ok)
                    return true;

                ct.pa.notify.error(res.data.Message, "Error");

                return false;
            },

            isValidDate(dt) {
                var date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
                return (!dt || date_regex.test(dt)) ? true : false;
            },


            runSearch() {

                this.v$.$touch();

                if (!this.hasError) {
                    this.isLoading = true;
                    return api.search.run(this.searchCriteria).then(res => {
                        if (this.handleResponse(res)) {
                            this.bailData = res.data.data;
                            this.setResultsView();
                        }
                        this.isLoading = false;
                    }).catch(error => {
                        ct.pa.reportError('Error retrieving search results', null, 'runSearch', 'Search.vue', error.response);
                        this.isLoading = false;
                    });

                }
            },

            searchTypeChange(searchType) {

                this.v$.$reset();
                this.searchCriteria.BeginDate = null;
                this.searchCriteria.EndDate = null;
                this.searchCriteria.FirstName = '';
                this.searchCriteria.LastName = '';
                this.searchCriteria.DOB = null;
                this.searchCriteria.LicenseNumber = '';

                if (searchType != this.searchType.BailAgent)
                    this.$refs.BeginDate.focus();
                else
                    this.$refs.LastName.focus();
            },

            setResultsView() {
                this.view = (this.bailData.length > 0) ? "results" : "noresults";
            },

            setSearchView() {
                this.view = 'search';
            },           
            download(obj) {

                return api.file.run(obj, 'BailRecord.csv').then(res => {
                }).catch(error => {
                    ct.incite.reportError('Error downloading bail record csv', null, 'download', 'Search.vue', error.response);
                });
            },
        },

        // criteria is validated only if the related search is used
        validations: {
            searchCriteria: {
                //LicenseNumber: {
                //    required: requiredIf(function () {
                //        return this.isBailAgentSearch
                //    })
                //},
                //FirstName: {
                //    required: requiredIf(function () {
                //        return this.isBailAgentSearch
                //    })
                //},
                LastName: {
                    required: requiredIf(function () {
                        return this.isBailAgentSearch
                    })
                },
                BeginDate: {
                    valid(dt) {
                        return this.isDateRangeSearch && this.isValidDate(dt)
                    },
                    required: requiredIf(function () {
                        return this.isDateRangeSearch
                    }),
                    minValue(dt) {
                        return (dt) ? (new Date(dt) > new Date(2022, 5, 30) && this.isDateRangeSearch) : true;
                    },
                },
                EndDate: {
                    valid(dt) { return this.isDateRangeSearch && this.isValidDate(dt) },
                    minValue(dt, { BeginDate }) {
                        return (dt) ? (new Date(dt) > new Date(BeginDate) && this.isDateRangeSearch) : true;
                    },
                    isDateRangeValid(dt, { BeginDate }) {
                        if (dt && BeginDate) {
                            let dtBegin = moment(BeginDate, "MM/DD/YYYY");
                            let dtEnd = moment(dt, "MM/DD/YYYY");
                            let years = dtEnd.diff(dtBegin, 'years');
                            return (years == 0 && this.isDateRangeSearch) ? true : false;
                        } else { return true; }

                    },
                }
            },
        }
    }
</script>
